import React from 'react';

import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../../common/Loading';

import getCategorias from '../../../../graphql/querys/otros/getCategorias.graphql';
import deleteCategoria from '../../../../graphql/mutations/otros/deleteCategoria.graphql';

import TablaCategorias from './TablaCategorias';
import { errorService } from '../../../../graphql/utils/utils';

const confirm = Modal.confirm;
@compose(
  graphql(getCategorias, { options: { fetchPolicy: 'network-only' } }),
  graphql(deleteCategoria, {
    name: 'deleteCategoria',
    options: {
      refetchQueries: [{ query: getCategorias }],
    },
  })
)
class VerCategorias extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      filtro: '',
    };

    this.onDelete = this.onDelete.bind(this);
  }

  onDelete(id) {
    //TODO: Hacer el onDelete.

    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar esta categoria?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props
          .deleteCategoria({
            variables: { _id: id },
          })
          // eslint-disable-next-line no-unused-vars
          .then(res => {
            notification.success({
              message: 'Categoria eliminada',
              description: 'Se ha eliminado correctamente la categoria',
            });
          })
          .catch(err => {
            console.log('Existio un error a la hora de eliminar la categoria');
            console.log(err);
            errorService(err, {
              _id: id,
            });
            Modal.error({
              title: 'Error en la eliminacion de la categoria',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    let listaCategorias = this.props.data.getCategorias;

    if (!listaCategorias) {
      listaCategorias = [];
    }

    return (
      <div>
        <TablaCategorias
          categorias={listaCategorias}
          history={this.props.history}
          onDelete={this.onDelete}
        />
      </div>
    );
  }
}

export default withApollo(VerCategorias);
